<div class="wrapper has-padding">
	<h1 class="bofa--heading is-4">Password changed successfully.</h1>
	<div class="bofa--alert has-background cool-gray-5 has-padding is-stacked">
		<ul class="has-no-padding has-no-margin">
			<li><span class="padding-top"> <img alt="information" src="assets/bofa_icon_info.svg" class="img-size"
						></span>If you have trouble accessing your application, please</li>
			<li class="padd-40">reach out to the contact listed in your invitation email.</li>
		</ul>
	</div>

	<div class="bofa--action_bar is-taller">
		<button (click)="navigateLogin()" class="bofa--button primary large">
			<span *ngIf="loginType != 4"> Click here to login to the Background Check Form
			</span>
			<span *ngIf="loginType == 4"> Click here to login to the Vendor Form
			</span>

		</button>
	</div>

</div>